import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import axios from 'axios'
import commonUtil from './util/commonUtil'
import arrayUtil from './util/arrayUtil'
import fileUtil from './util/fileUtil'
import mavonEditor from 'mavon-editor'

import "element-ui/lib/theme-chalk/index.css"
import 'mavon-editor/dist/css/index.css'

import '@/assets/css/my_icon.css'
import '@/assets/font/font.css'

import "./axios"
import "./permission"

Element.Dialog.props.closeOnClickModal.default=false
Element.Dialog.props.closeOnPressEscape.default=false
Element.Dialog.props.showClose.default=false

Vue.use(Element)
Vue.use(mavonEditor)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.commonUtil = commonUtil
Vue.prototype.arrayUtil = arrayUtil
Vue.prototype.fileUtil = fileUtil


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
